import type { ProjectDetail } from '@stores/project/types';
import type { ProjectListViewMode } from '../ProjectList/const';

export interface ProjectCardProps {
  project: ProjectDetail;
  viewMode?: ProjectListViewMode;
}

export const DAY_7_INTERVAL = 7 * 24 * 60 * 60 * 1000;
